module.exports = "<div class=\"op-modal-container\">\n\n  <div class=\"op-modal-title -simple\">\n    Delete {{$ctrl.network.name}} Network?\n  </div>\n\n  <div class=\"op-modal-dialog\">\n    <span>\n      Only the network structure will be deleted. All customer accounts within the network will still be available.\n    </span>\n  </div>\n\n  <div class=\"op-modal-buttons -centered\">\n    <button ng-click=\"$ctrl.close()\" class=\"btn-gray\"><span>Cancel Deletion</span></button>\n    <button ng-click=\"$ctrl.deleteNetwork()\" class=\"btn-red\"><span>Delete Network</span></button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/cn/deletenetwork.html
// module id = 39
// module chunks = 0